import PropTypes from 'prop-types'
import {Skeleton, Text} from '@chakra-ui/react'

const SubsectionSubtitle = ({children, isLoading, color}) => {
  return (
    <Skeleton width="fit-content" isLoaded={!isLoading}>
      <Text textStyle="body-intro" pb="xs" color={color}>
        {children}
      </Text>
    </Skeleton>
  )
}

SubsectionSubtitle.defaultProps = {
  isLoading: false,
}

SubsectionSubtitle.propTypes = {
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  color: PropTypes.string,
}

SubsectionSubtitle.defaultProps = {
  color: null,
}

export default SubsectionSubtitle
